import React, { Component } from 'react';

class Ad extends Component {
  componentDidMount() {
    const script = document.createElement('script');
    script.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
    script.async = true;
    document.head.appendChild(script);
  }

  render() {
    return (
      <div>
        <ins className='adsbygoogle'
          style={{ display: 'block' }}
          data-ad-client='ca-pub-4565925289497624'
          data-ad-slot='9558449685'
          data-ad-format='fluid'
          data-ad-layout-key='-f4+g-v-4z+c4' />
        <script>
          (adsbygoogle = window.adsbygoogle || []).push({});
        </script>
      </div>
    );
  }
}

export default Ad;
